import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { useInfiniteHits } from "react-instantsearch";
import NoResultsMessage from "../../algolia_search/no_results_message";
import useInfiniteScroll from "../../hooks/use_infinite_scroll";
import StoryIdeaCardGrid from "../card/StoryIdeaCardGrid";
import StoryIdeaCardList from "../card/StoryIdeaCardList";
import storyIdeaListActionColumnWidth from "../card/listActionColumn";
import { listHeaderRowStyle } from "../../source_directory/utils";

function InfiniteHits({ viewMode = "grid" }) {
  const { hits, isLastPage, showMore } = useInfiniteHits();
  const hasMore = !isLastPage;
  const isSignedIn = !!globalThis.Qwoted?.CURRENT_USER_ID;
  const actionColumnWidth = storyIdeaListActionColumnWidth(isSignedIn);

  const [lastTriggeredAt, scrollTriggerRef] = useInfiniteScroll({ hasMore });

  useEffect(() => {
    if (lastTriggeredAt > 0) showMore();
  }, [lastTriggeredAt, showMore]);

  if (viewMode === "list") {
    return (
      <>
        <NoResultsMessage hits={hits} />
        {hits.length > 0 && (
          <div className="sd-list-header-row" style={{ ...listHeaderRowStyle, gap: 14, padding: "0 19px 8px" }}>
            <span style={{ flex: "0 0 230px" }}>Source</span>
            <span style={{ flex: 1 }}>Story</span>
            <span style={{ flex: "0 0 90px" }}>Posted</span>
            {actionColumnWidth > 0 && <span aria-hidden="true" style={{ flex: `0 0 ${actionColumnWidth}px` }} />}
          </div>
        )}
        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          {hits.map((hit) => (
            <StoryIdeaCardList key={hit.objectID} hit={hit} />
          ))}
        </div>
        {hasMore && <div ref={scrollTriggerRef} />}
      </>
    );
  }

  return (
    <>
      <NoResultsMessage hits={hits} />
      <div className="sd-cards-grid">
        {hits.map((hit) => (
          <StoryIdeaCardGrid key={hit.objectID} hit={hit} />
        ))}
      </div>
      {hasMore && <div ref={scrollTriggerRef} className="sd-cards-grid" />}
    </>
  );
}

InfiniteHits.propTypes = {
  viewMode: PropTypes.oneOf(["grid", "list"]),
};

export default InfiniteHits;
